import { PageBreadcrumbHeader } from "#/features/global-ui/page-header"
import { PageLayout } from "#/features/global-ui/page-layout"
import { Stack, Typography, Box, Link } from "@carrotfertility/carotene-core"
import React, { useContext } from "react"
import { ExpertBioModalContext, ExpertBioModalContextProvider } from "#/components/expert-bios/expert-bio-modal"
import { ExpertBio } from "#/components/read/shared/ExpertBioMapper"
import { Title } from "#/services/page-title/Title"
import { useIntl } from "react-intl"

export const BookAgainExpertBio = ({ expertBio }: { expertBio: ExpertBio }) => {
  const { openExpertBioModal } = useContext(ExpertBioModalContext)
  const { id, slug, headshot, name } = expertBio
  return (
    <Stack gap={(theme) => theme.tokens.spacing.sm} direction="row">
      <Box
        component="img"
        src={headshot?.file?.url}
        alt=""
        height="4.5rem"
        width="4.5rem"
        borderRadius={(theme) => theme.tokens.borderRadius.md}
      />
      <Stack direction="column">
        <Typography variant="body2" color={(theme) => theme.palette.text.secondary}>
          <Link
            component="button"
            textAlign="start"
            color="inherit"
            data-analytics-id="care-team-book-again-expert-bio-link"
            data-expert-id={`${slug}-${id}`}
            onClick={() => openExpertBioModal({ expertBio: expertBio })}
          >
            {name}
          </Link>
        </Typography>
      </Stack>
    </Stack>
  )
}

export const BookAgainPageLayout = ({
  breadcrumbs,
  content,
  contactUsCard
}: {
  breadcrumbs: JSX.Element
  content: JSX.Element
  contactUsCard: JSX.Element
}): JSX.Element => {
  const intl = useIntl()
  return (
    <PageLayout header={<PageBreadcrumbHeader breadcrumbs={breadcrumbs} />}>
      <Title
        title={intl.formatMessage({ defaultMessage: "Book again" })}
        productTitle={intl.formatMessage({ defaultMessage: "Care Team" })}
      />
      <ExpertBioModalContextProvider>
        <Stack
          direction={{ lg: "row" }}
          justifyContent="space-between"
          marginBlockStart="4rem"
          gap={(theme) => theme.tokens.spacing.xl}
        >
          <Stack gap={(theme) => theme.tokens.spacing.xl} width={"100%"} maxWidth={{ md: "100%", lg: "36rem" }}>
            {content}
          </Stack>
          {contactUsCard}
        </Stack>
      </ExpertBioModalContextProvider>
    </PageLayout>
  )
}
